import api from '../../lib/api';
import { apiErrorMessage } from '../../helpers/api';

export const UsersActionsTypes = {
  FETCH_USERS_STARTED: 'FETCH_USERS_STARTED',
  FETCH_USERS_SUCCESS: 'FETCH_USERS_SUCCESS',
  FETCH_USERS_FAILURE: 'FETCH_USERS_FAILURE',
  FETCH_USERS_COUNT_STARTED: 'FETCH_USERS_COUNT_STARTED',
  FETCH_USERS_COUNT_SUCCESS: 'FETCH_USERS_COUNT_SUCCESS',
  FETCH_USERS_COUNT_FAILURE: 'FETCH_USERS_COUNT_FAILURE',
  FETCH_USER_BYID_STARTED: 'FETCH_USER_BYID_STARTED',
  FETCH_USER_BYID_SUCCESS: 'FETCH_USER_BYID_SUCCESS',
  FETCH_USER_BYID_FAILURE: 'FETCH_USER_BYID_FAILURE',
  EDIT_USER_BYID_STARTED: 'EDIT_USER_BYID_STARTED',
  EDIT_USER_BYID_SUCCESS: 'EDIT_USER_BYID_SUCCESS',
  EDIT_USER_BYID_FAILURE: 'EDIT_USER_BYID_FAILURE',
  UPDATE_USER_IMAGE_SUCCESS: 'UPDATE_USER_IMAGE_SUCCESS',
  FETCH_RIDER_CASH_FLOW_SUCCESS: 'FETCH_RIDER_CASH_FLOW_SUCCESS',
  FETCH_DRIVER_CASH_FLOW_SUCCESS: 'FETCH_DRIVER_CASH_FLOW_SUCCESS',
  FETCH_DRIVER_BALANCE_SUCCESS: 'FETCH_DRIVER_BALANCE_SUCCESS',
  FETCH_DRIVER_BALANCE_FAILURE: 'FETCH_DRIVER_BALANCE_FAILURE',
  FETCH_DRIVER_PAYMENT_LOG_SUCCESS: 'FETCH_DRIVER_PAYMENT_LOG_SUCCESS',
  FETCH_DRIVER_PAYMENT_LOG_FAILURE: 'FETCH_DRIVER_PAYMENT_LOG_FAILURE',
  FETCH_PAYMENT_SOURCES_SUCCESS: 'FETCH_PAYMENT_SOURCES_SUCCESS',
  FETCH_SESSIONS_SUCCESS: 'FETCH_SESSIONS_SUCCESS',
  FETCH_DRIVER_SCORE_SUCCESS: 'FETCH_DRIVER_SCORE_SUCCESS',
  FETCH_AVERAGE_DRIVER_SCORES_SUCCESS: 'FETCH_AVERAGE_DRIVER_SCORES_SUCCESS',
  FETCH_RIDE_HISTORY_SUCCESS: 'FETCH_RIDE_HISTORY_SUCCESS',
  REFUND_RIDE_SUCCESS: 'REFUND_RIDE_SUCCESS',
  RELOAD_USER_SUCCESS: 'RELOAD_USER_SUCCESS',
  FETCH_DRIVE_HISTORY_SUCCESS: 'FETCH_DRIVE_HISTORY_SUCCESS',
  FETCH_PROMOTIONS_SUCCESS: 'FETCH_PROMOTIONS_SUCCESS',
  FETCH_AVAILABLE_PROMOTIONS_SUCCESS: 'FETCH_AVAILABLE_PROMOTIONS_SUCCESS',
  FETCH_REFERRALS_SUCCESS: 'FETCH_REFERRALS_SUCCESS',
  FETCH_REFERRALS_FAILURE: 'FETCH_REFERRALS_FAILURE',
  FETCH_BLACKLISTED_DATES_SUCCESS: 'FETCH_BLACKLISTED_DATES_SUCCESS',
  FETCH_BLACKLISTED_TIMES_SUCCESS: 'FETCH_BLACKLISTED_TIMES_SUCCESS',
  FETCH_CURRENT_LOCATION_SUCCESS: 'FETCH_CURRENT_LOCATION_SUCCESS',
  FETCH_CURRENT_LOCATION_FAILURE: 'FETCH_CURRENT_LOCATION_FAILURE',
  FETCH_CREDIT_LOG_SUCCESS: 'FETCH_CREDIT_LOG_SUCCESS',
  ADD_CREDITS_SUCCESS: 'ADD_CREDITS_SUCCESS',
  FETCH_USER_NOTES_SUCCESS: 'FETCH_USER_NOTES_SUCCESS',
  FETCH_USER_NOTES_FAILURE: 'FETCH_USER_NOTES_FAILURE',
  ADD_USER_NOTE_SUCCESS: 'ADD_USER_NOTE_SUCCESS',
  EDIT_USER_NOTE_SUCCESS: 'EDIT_USER_NOTE_SUCCESS',
  DELETE_USER_STARTED: 'DELETE_USER_STARTED',
  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
  DELETE_USER_FAILURE: 'DELETE_USER_FAILURE',

  RESET_STATE: 'RESET_STATE',
  RESET_ERROR: 'RESET_ERROR',
};

export const fetchUsers =
  ({ offset, limit }) =>
  async (dispatch) => {
    dispatch({
      type: UsersActionsTypes.FETCH_USERS_STARTED,
    });
    try {
      const users = await api.users.getUsers({ offset, limit });
      dispatch({
        type: UsersActionsTypes.FETCH_USERS_SUCCESS,
        payload: users,
      });
    } catch (error) {
      dispatch({
        type: UsersActionsTypes.FETCH_USERS_FAILURE,
        payload: apiErrorMessage(error),
      });
    }
  };

export const fetchUsersCount = () => async (dispatch) => {
  dispatch({
    type: UsersActionsTypes.FETCH_USERS_COUNT_STARTED,
  });
  try {
    const users = await api.users.getUsers({ offset: 0, limit: 1 });
    dispatch({
      type: UsersActionsTypes.FETCH_USERS_COUNT_SUCCESS,
      payload: users.count,
    });
  } catch (error) {
    dispatch({
      type: UsersActionsTypes.FETCH_USERS_COUNT_FAILURE,
      payload: apiErrorMessage(error),
    });
  }
};

export const fetchUserById = (id) => async (dispatch) => {
  dispatch({
    type: UsersActionsTypes.FETCH_USER_BYID_STARTED,
  });
  try {
    const user = await api.users.getUser({ id });
    dispatch({
      type: UsersActionsTypes.FETCH_USER_BYID_SUCCESS,
      payload: user,
    });
    return { success: true };
  } catch (error) {
    dispatch({
      type: UsersActionsTypes.FETCH_USER_BYID_FAILURE,
      payload: apiErrorMessage(error),
    });
    return { success: false };
  }
};

export const fetchCurrentLocation = (userId) => async (dispatch) => {
  try {
    const location = await api.users.getCurrentLocation(userId);
    dispatch({
      type: UsersActionsTypes.FETCH_CURRENT_LOCATION_SUCCESS,
      payload: { userId, location },
    });
  } catch (error) {
    dispatch({
      type: UsersActionsTypes.FETCH_CURRENT_LOCATION_FAILURE,
      payload: { userId, error },
    });
  }
};

export const getRiderCashFlow = (userId) => async (dispatch) => {
  try {
    const data = await api.users.getRiderCashFlow({ id: userId });
    dispatch({
      type: UsersActionsTypes.FETCH_RIDER_CASH_FLOW_SUCCESS,
      payload: data,
    });
  } catch {
    return { success: false };
  }
};

export const getCreditLog =
  (userId, offset = 0, limit = 25) =>
  async (dispatch) => {
    try {
      const data = await api.users.getCreditLog({ id: userId, offset, limit });
      dispatch({
        type: UsersActionsTypes.FETCH_CREDIT_LOG_SUCCESS,
        payload: data,
      });
      return { success: true };
    } catch {
      return { success: false };
    }
  };

export const getDriverCashFlow = (userId) => async (dispatch) => {
  try {
    const data = await api.users.getDriverCashFlow({ id: userId });
    dispatch({
      type: UsersActionsTypes.FETCH_DRIVER_CASH_FLOW_SUCCESS,
      payload: data,
    });
  } catch {
    return { success: false };
  }
};

export const getDriverBalance = (userId) => async (dispatch) => {
  try {
    const data = await api.users.getDriverBalance({ id: userId });
    dispatch({
      type: UsersActionsTypes.FETCH_DRIVER_BALANCE_SUCCESS,
      payload: data,
    });
    return { success: true };
  } catch (error) {
    dispatch({
      type: UsersActionsTypes.FETCH_DRIVER_BALANCE_FAILURE,
      payload: error,
    });
    return { success: false };
  }
};

// Fetch a page of the driver payment log. When `cursor` is provided the page is
// appended (load more); otherwise it replaces the list (initial load / refresh).
export const getDriverPaymentLog =
  (userId, cursor = null, limit = 25) =>
  async (dispatch) => {
    try {
      const data = await api.users.getDriverPaymentLog({ id: userId, cursor, limit });
      dispatch({
        type: UsersActionsTypes.FETCH_DRIVER_PAYMENT_LOG_SUCCESS,
        payload: { ...data, append: !!cursor },
      });
      return { success: true };
    } catch (error) {
      dispatch({ type: UsersActionsTypes.FETCH_DRIVER_PAYMENT_LOG_FAILURE });
      return { success: false, error };
    }
  };

export const addDriverPayment =
  ({ userId, amount, reason, description }) =>
  async (dispatch) => {
    try {
      const response = await api.users.addDriverPayment({ userId, amount, reason, description });

      if (response.status === 201 || response.status === 200) {
        // Refresh the balance and the log from the source of truth after the payment
        await getDriverBalance(userId)(dispatch);
        await getDriverPaymentLog(userId)(dispatch);
        return { success: true, error: null };
      }

      return { success: false, error: response.data?.error };
    } catch (error) {
      return { success: false, error };
    }
  };

export const reverseDriverPayment =
  ({ userId, auditLogId, description }) =>
  async (dispatch) => {
    try {
      const response = await api.users.reverseDriverPayment({ userId, auditLogId, description });

      if (response.status === 201 || response.status === 200) {
        // Refresh the balance and the log from the source of truth after the reversal
        await getDriverBalance(userId)(dispatch);
        await getDriverPaymentLog(userId)(dispatch);
        return { success: true, error: null };
      }

      return { success: false, error: response.data?.error };
    } catch (error) {
      return { success: false, error };
    }
  };

export const getPaymentSources = (userId) => async (dispatch) => {
  try {
    const data = await api.users.getPaymentSources({ id: userId });
    dispatch({
      type: UsersActionsTypes.FETCH_PAYMENT_SOURCES_SUCCESS,
      payload: data,
    });
  } catch {
    return { success: false };
  }
};

export const removePaymentSource = (userId, sourceId) => async (dispatch) => {
  try {
    const data = await api.users.removePaymentSource({ id: userId, sourceId });
    dispatch({
      type: UsersActionsTypes.FETCH_PAYMENT_SOURCES_SUCCESS,
      payload: data,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const setDefaultPaymentSource = (userId, sourceId) => async (dispatch) => {
  try {
    const data = await api.users.setDefaultPaymentSource({ id: userId, sourceId });
    dispatch({
      type: UsersActionsTypes.FETCH_PAYMENT_SOURCES_SUCCESS,
      payload: data,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const editUserById = (id, update) => async (dispatch) => {
  dispatch({
    type: UsersActionsTypes.EDIT_USER_BYID_STARTED,
  });
  try {
    const user = await api.users.editUser({ id, update });
    dispatch({
      type: UsersActionsTypes.EDIT_USER_BYID_SUCCESS,
      payload: user,
    });
    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: apiErrorMessage(error),
    };
  }
};

// Fetch a presigned S3 URL for uploading a user's profile photo. Mirrors the
// driver document flow (getDocumentUploadUrl).
export const getUserImageUploadUrl = (id) => async () => {
  try {
    const data = await api.users.getProfilePhotoUploadUrl({ id });
    return { success: true, data };
  } catch (error) {
    return { success: false, error };
  }
};

// Finalize an uploaded profile photo via the commit endpoint. Returns the
// business { result, imageUrl }: on result "set" the photo was saved (and, for
// drivers, they are now eligible) — we merge the committed public imageUrl into
// the selected user in place so the rest of the loaded user (userRawUnsafe,
// homeCity, etc.) is preserved. On "failed_match" / "no_face_detected" nothing is
// persisted; the caller decides whether to offer the bypass override. Pass
// bypassVerification: true to override a driver's failed face-match (admin has
// manually verified the photo against the license).
export const commitUserImage =
  (id, imageUrl, { bypassVerification = false, bypassReason } = {}) =>
  async (dispatch) => {
    try {
      const { result, imageUrl: committedImageUrl } = await api.users.commitProfilePhoto({
        id,
        imageUrl,
        bypassVerification,
        bypassReason,
      });
      if (result === 'set') {
        dispatch({
          type: UsersActionsTypes.UPDATE_USER_IMAGE_SUCCESS,
          payload: { imageUrl: committedImageUrl },
        });
      }
      return { success: true, result, imageUrl: committedImageUrl };
    } catch (error) {
      return {
        success: false,
        error: apiErrorMessage(error),
      };
    }
  };

export const getSessions = (userId) => async (dispatch) => {
  try {
    const sessions = await api.users.getSessions({ id: userId });
    dispatch({
      type: UsersActionsTypes.FETCH_SESSIONS_SUCCESS,
      payload: sessions,
    });
  } catch {
    return { success: false };
  }
};

export const revokeSession = (userId, sessionId) => async (dispatch) => {
  try {
    const sessions = await api.users.revokeSession({ id: userId, sessionId });
    dispatch({
      type: UsersActionsTypes.FETCH_SESSIONS_SUCCESS,
      payload: sessions,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const getDriverScore = (userId) => async (dispatch) => {
  try {
    const score = await api.users.getDriverScore({ id: userId });
    dispatch({
      type: UsersActionsTypes.FETCH_DRIVER_SCORE_SUCCESS,
      payload: score,
    });
  } catch {
    return { success: false };
  }
};

export const getAverageDriverScores = () => async (dispatch) => {
  try {
    const score = await api.users.getAverageDriverScores();
    dispatch({
      type: UsersActionsTypes.FETCH_AVERAGE_DRIVER_SCORES_SUCCESS,
      payload: score,
    });
  } catch {
    return { success: false };
  }
};

export const getRideHistory = (id, offset, limit) => async (dispatch) => {
  try {
    const history = await api.users.getRideHistory({ id, offset, limit });
    dispatch({
      type: UsersActionsTypes.FETCH_RIDE_HISTORY_SUCCESS,
      payload: history,
    });
  } catch {
    return { success: false };
  }
};

export const refundRide =
  ({ userId, rideId, amount, reasonId, reasonDescription }) =>
  async (dispatch) => {
    try {
      const ride = await api.users.refundRide({ rideId, amount, reason: reasonId, description: reasonDescription });
      dispatch({
        type: UsersActionsTypes.REFUND_RIDE_SUCCESS,
        payload: ride,
      });

      const user = await api.users.getUser({ id: userId });
      dispatch({
        type: UsersActionsTypes.RELOAD_USER_SUCCESS,
        payload: user,
      });

      return { success: true };
    } catch (e) {
      console.log(e);
      return { success: false, error: e };
    }
  };

export const getDriveHistory = (id, offset, limit) => async (dispatch) => {
  try {
    const history = await api.users.getDriveHistory({ id, offset, limit });
    dispatch({
      type: UsersActionsTypes.FETCH_DRIVE_HISTORY_SUCCESS,
      payload: history,
    });
  } catch {
    return { success: false };
  }
};

export const getPromotions = (id) => async (dispatch) => {
  try {
    const promotions = await api.users.getPromotions({ id });
    dispatch({
      type: UsersActionsTypes.FETCH_PROMOTIONS_SUCCESS,
      payload: promotions,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

// Monotonic counter stamped on every getReferrals call. The userId tag alone
// only rejects a response for the *wrong* user; it can't tell two in-flight
// requests for the *same* user apart. Re-visiting a user (A -> B -> A) fires
// a second request while the first may still be in flight, and network
// timing gives no guarantee the first one resolves first. The reducer only
// applies a response whose requestId is >= the latest one it's seen, so an
// older, slower response can never overwrite a newer one that already landed.
let referralsRequestSeq = 0;

export const getReferrals = (id) => async (dispatch) => {
  const requestId = ++referralsRequestSeq;
  try {
    const referrals = await api.users.getReferrals({ id });
    // Tag the response with its user id (rejected if the operator has since
    // navigated to a different user) and request id (rejected if a newer
    // request for this same user has already resolved).
    dispatch({
      type: UsersActionsTypes.FETCH_REFERRALS_SUCCESS,
      payload: { userId: id, referrals, requestId },
    });
    return { success: true };
  } catch {
    // Surface the error so the card shows an explicit error state instead of a
    // false "no referrals" empty state.
    dispatch({
      type: UsersActionsTypes.FETCH_REFERRALS_FAILURE,
      payload: { userId: id, requestId },
    });
    return { success: false };
  }
};

export const removePromotion = (id, promoId) => async (dispatch) => {
  try {
    await api.users.removePromo({ id, promoId });
    const promotions = await api.users.getPromotions({ id });
    dispatch({
      type: UsersActionsTypes.FETCH_PROMOTIONS_SUCCESS,
      payload: promotions,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const getAvailablePromotions = (q) => async (dispatch) => {
  try {
    const promotions = await api.search.searchPromos({ q, offset: 0, limit: 50 });
    dispatch({
      type: UsersActionsTypes.FETCH_AVAILABLE_PROMOTIONS_SUCCESS,
      payload: promotions,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const addPromotions = (id, codes) => async (dispatch) => {
  try {
    await api.users.addPromos({ id, codes });
    const promotions = await api.users.getPromotions({ id });
    dispatch({
      type: UsersActionsTypes.FETCH_PROMOTIONS_SUCCESS,
      payload: promotions,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const addBlacklistedDate = (id, date) => async (dispatch) => {
  try {
    await api.users.addBlacklistedDate({ id, date });
    const user = await api.users.getUser({ id });
    dispatch({
      type: UsersActionsTypes.FETCH_BLACKLISTED_DATES_SUCCESS,
      payload: user.blacklistedDates,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const removeBlacklistedDate = (id, date) => async (dispatch) => {
  try {
    await api.users.removeBlacklistedDate({ id, date });
    const user = await api.users.getUser({ id });
    dispatch({
      type: UsersActionsTypes.FETCH_BLACKLISTED_DATES_SUCCESS,
      payload: user.blacklistedDates,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const addBlacklistedDateTime = (id, dateTime) => async (dispatch) => {
  try {
    await api.users.addBlacklistedDateTime({ id, dateTime });
    const user = await api.users.getUser({ id });
    dispatch({
      type: UsersActionsTypes.FETCH_BLACKLISTED_TIMES_SUCCESS,
      payload: user.blacklistedTimes,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const removeBlacklistedDateTime = (id, dateTime) => async (dispatch) => {
  try {
    await api.users.removeBlacklistedDateTime({ id, dateTime });
    const user = await api.users.getUser({ id });
    dispatch({
      type: UsersActionsTypes.FETCH_BLACKLISTED_TIMES_SUCCESS,
      payload: user.blacklistedTimes,
    });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const resetState = () => (dispatch) => {
  dispatch({
    type: UsersActionsTypes.RESET_STATE,
  });
};

export const addCredits =
  ({ userId, reason, description, items, rideId }) =>
  async (dispatch) => {
    function _findUpdatedValue(items, type) {
      return items.find((item) => item.type === type)?.updatedValue ?? null;
    }

    try {
      const parameters = { userId, reason, description, items, rideId };
      const response = await api.users.addCredits(parameters);

      const cancellationCredit = _findUpdatedValue(items, 'CANCELLATION');
      const creditAmount = _findUpdatedValue(items, 'GENERAL');
      const referralCredit = _findUpdatedValue(items, 'REFERRAL');

      if (response.status === 201) {
        // Only updated-by-user credits will be kept
        const payload = {
          ...(cancellationCredit !== null && { cancellationCredit }),
          ...(creditAmount !== null && { creditAmount }),
          ...(referralCredit !== null && { referralCredit }),
          userId: String(userId),
        };
        dispatch({
          type: UsersActionsTypes.ADD_CREDITS_SUCCESS,
          payload,
        });
        return { success: true, error: null };
      }

      return { success: false, error: response.data.error };
    } catch (error) {
      return { success: false, error };
    }
  };

export const getUserNotes = (userId) => async (dispatch) => {
  try {
    const data = await api.users.getUserNotes({ id: userId });
    dispatch({
      type: UsersActionsTypes.FETCH_USER_NOTES_SUCCESS,
      payload: data,
    });
    return { success: true };
  } catch {
    // The reducer keeps existing notes if they're already loaded, and only
    // falls back to an empty list on the initial load (when state is null) so
    // the card shows its empty state instead of a perpetual spinner.
    dispatch({ type: UsersActionsTypes.FETCH_USER_NOTES_FAILURE });
    return { success: false };
  }
};

export const addUserNote =
  ({ userId, body }) =>
  async (dispatch) => {
    try {
      const response = await api.users.addUserNote({ userId, body });

      if (response.status === 200 || response.status === 201) {
        dispatch({ type: UsersActionsTypes.ADD_USER_NOTE_SUCCESS });
        return { success: true, error: null };
      }

      return { success: false, error: response.data?.error };
    } catch (error) {
      return { success: false, error };
    }
  };

export const editUserNote =
  ({ userId, noteId, body }) =>
  async (dispatch) => {
    try {
      const response = await api.users.editUserNote({ userId, noteId, body });

      if (response.status === 200) {
        dispatch({ type: UsersActionsTypes.EDIT_USER_NOTE_SUCCESS });
        return { success: true, error: null };
      }

      return { success: false, error: response.data?.error };
    } catch (error) {
      return { success: false, error };
    }
  };

export const deleteUser = (id) => async (dispatch) => {
  dispatch({ type: UsersActionsTypes.DELETE_USER_STARTED });
  try {
    await api.users.deleteUser({ id });
    dispatch({ type: UsersActionsTypes.DELETE_USER_SUCCESS, payload: id });
    return { success: true, error: null };
  } catch (error) {
    dispatch({ type: UsersActionsTypes.DELETE_USER_FAILURE });
    return { success: false, error: apiErrorMessage(error) };
  }
};
